import { Languages } from "lucide-react";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

export const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "ta", label: "தமிழ்" },
  { code: "hi", label: "हिंदी" },
  { code: "te", label: "తెలుగు" },
  { code: "ml", label: "മലയാളം" },
];

export const LanguageSelector = ({ compact = false }) => {
  const { user, setUser } = useAuth();
  const value = user?.language || "en";

  const change = async (code) => {
    if (code === value) return;
    setUser((u) => ({ ...u, language: code }));
    try {
      await api.patch("/auth/me/preferences", { language: code });
      toast.success(`AI language set to ${LANGUAGES.find((l) => l.code === code)?.label}`);
    } catch {
      setUser((u) => ({ ...u, language: value }));
      toast.error("Could not save language");
    }
  };

  return (
    <Select value={value} onValueChange={change}>
      <SelectTrigger data-testid="language-selector" aria-label="AI output language"
        className={compact ? "h-9 w-[118px] bg-white/5 border-white/10 text-xs font-medium" : "h-10 bg-white/5 border-white/10 text-sm"}>
        <Languages className="w-4 h-4 text-cyan-400 shrink-0 mr-1.5" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="bg-[#121824] border-white/10 text-white" data-testid="language-options">
        {LANGUAGES.map((l) => (
          <SelectItem key={l.code} value={l.code} data-testid={`language-option-${l.code}`} className="focus:bg-white/10 focus:text-white">{l.label}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
